import { render, staticRenderFns } from "./load.vue?vue&type=template&id=a7fda708&scoped=true"
import script from "./load.vue?vue&type=script&lang=js"
export * from "./load.vue?vue&type=script&lang=js"
import style0 from "./load.vue?vue&type=style&index=0&id=a7fda708&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fda708",
  null
  
)

export default component.exports